import { ErrorMessage, type FieldValuesFromFieldErrors } from '@hookform/error-message';
import type { FieldErrors, FieldName, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { queryStringToRecord } from '@/utils/query-string';

interface Props<TFieldValues extends FieldValues> {
  name: FieldName<FieldValuesFromFieldErrors<FieldErrors<TFieldValues>>>;
  errors: FieldErrors<TFieldValues>;
  helperText?: string;
}

export function FieldMessage<TF extends FieldValues = Record<string, never>>({
  name,
  errors,
  helperText = '',
}: Props<TF>) {
  const { t } = useTranslation();

  return (
    <div className='label empty:hidden'>
      {helperText && <span className='label-text-alt'>{helperText}</span>}

      <ErrorMessage
        key={name}
        name={name}
        errors={errors}
        render={({ message }) => {
          if (!message) return null;

          if (message.includes('|')) {
            const [key = '', qs = ''] = message.split('|');
            const params = queryStringToRecord(qs);
            return <span className='label-text-alt text-error'>{t(key, params)}</span>;
          }

          return <span className='label-text-alt text-error'>{t(message)}</span>;
        }}
      />
    </div>
  );
}
